"use client";

import { Layout } from 'antd';
import styles from './Formats.module.scss';
import { ScrollReveal } from '@/shared/ui/ScrollReveal';
import { useTranslations } from 'next-intl';
import { AutoScrollCarousel } from '@/shared/ui/AutoScrollCarousel';
import { ImageIcon } from '@/shared/constants/icon';

const { Content } = Layout;

const formatData = [
  {
    id: 1,
    title: 'jpg',
    desc: 'jpgDesc',
  },
  {
    id: 2,
    title: 'png',
    desc: 'pngDesc',
  },
  {
    id: 3,
    title: 'webp',
    desc: 'webpDesc',
  },
  {
    id: 4,
    title: 'bmp',
    desc: 'bmpDesc',
  },
  {
    id: 5,
    title: 'gif',
    desc: 'gifDesc',
  },
  {
    id: 6,
    title: 'svg',
    desc: 'svgDesc',
  },
  {
    id: 7,
    title: 'ico',
    desc: 'icoDesc',
  },
];

export const Formats = () => {
  const tKey = 'textRemover.formats';
  const t = useTranslations(tKey);

  return (
    <Content className={styles.root}>
      <ScrollReveal>
        <h1>{t('supportedFormats')}</h1>
      </ScrollReveal>

      <AutoScrollCarousel
        data={formatData}
        tKey={tKey}
        icon={<ImageIcon color="var(--color-primary)" size={'2.5vw'} />}
      />
    </Content>
  );
};
